module.exports = __webpack_public_path__ + "static/web-cover-2d32be69d007eda1bc691b119b5ff041.jpg";